import axios from '@/utils/request.js'

export const getUserClientId = (telphone) => { // 查询登录客户的客户ID
  return axios.get(`/goods/gas/client/getUserClientId/${telphone}`)
}

export const getUserGoodsList = (params) => { // 查询用户可以购买的商品列表
  return axios.post('/goods/gas/agentUserGoods/getUserGoodsList', params)
}

export const getUserAgentList = (userId) => { // 查询用户对应的商家列表
  return axios.get(`/goods/gas/agentUserGoods/getUserAgentList/${userId}`)
}
